import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import {
  DataProtectionDashboardMetrics,
  DataProtectionDashboardService,
} from 'src/app/features/data-protection/auth-tools/data-protection-dashboard/dashboard.service';
import {
  DataProtectionDashboardChartData,
  DataProtectionReportService,
} from 'src/app/features/data-protection/reports/reports.service';

export interface DataProtectionDashboardResolvedData {
  dashBoardData: DataProtectionDashboardMetrics;
  chartData: DataProtectionDashboardChartData;
}

@Injectable({ providedIn: 'root' })
export class DataProtectionDashboardDataResolver implements Resolve<DataProtectionDashboardResolvedData> {
  constructor(
    private readonly dashboardService: DataProtectionDashboardService,
    private readonly reportService: DataProtectionReportService,
  ) {}

  resolve(): Observable<DataProtectionDashboardResolvedData> {
    const filter = 'all_time';
    return forkJoin({
      dashBoardData: this.dashboardService.getDpDashboardData(),
      chartData: this.reportService.getDpDashboardChartData(filter),
    });
  }
}
